import { InjectionToken } from '@angular/core';
import { StoreConfig } from '@ngrx/store';

import { State } from './onboarding.reducer';

export const ONBOARDING_STORAGE_KEYS = new InjectionToken<keyof State>(
  'OnboardingStorageKeys',
);
export const ONBOARDING_STORAGE_KEY = new InjectionToken<string[]>(
  'OnboardingStorage',
);
export const ONBOARDING_CONFIG_TOKEN = new InjectionToken<StoreConfig<State>>(
  'OnboardingConfigToken',
);
